export default __webpack_public_path__ + "static/media/html-logo.1d7b133e.png";